export const fastMasterControlPayload = (checkOption, option) => {
  switch (checkOption) {
    case "instantHeatOn":
      return { instant_temp: option, on_switch: 1 };
    case "instantHeatOff":
      return { on_switch: 0 };
    case "snowSensorOn":
      return { snow_enabled: 1 };
    case "fanOnly":
      return { fan: option ? 1 : 0 };
    default:
      return { snow_enabled: 0 };
  }
};
